export default __webpack_public_path__ + "pgnv-assets/f3c91b7aaf52ada7871d7ce1781bc3cb.png";